module.exports = __webpack_public_path__ + "static/media/college.3c33fbf7.svg";